import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setIsLangauage, setLoginNew } from '../../store/LoginNew/loginNew.slice'
import { setIsNavigationOpen, setIsNavigationID, setIsNavigationName } from '../../store/navigationHeaderMenu/navigationHeaderMenu.slice';
import { setSlotCasinoPopUp, openSlotCasinoPopUp } from '../../store/slotCasinoPopUp/slotCasinoPopUp.slice'
import { setCasinoType } from '../../store/casinoprovider/casinoprovider.slice';
import { setLoginNavigationData } from '../../store/loginNavigation/LoginNavigation.slice';
import { setComingSoonModal } from '../../store/modals/comingSoonModal.slice';
import { requestRacingPageData } from '../../store/racingPage/racingPage.thunks';

export const connectLeftSideMenu = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
      menu: state.menu,
      auth: state.auth,
      user: state.user,
      version: state.version,
      language: state.loginNew.language,
    }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      setLoginNew,
      setSlotCasinoPopUp,
      openSlotCasinoPopUp,
      setIsNavigationOpen,
      setIsNavigationID,
      setIsNavigationName,
      setCasinoType,
      setLoginNavigationData,
      setComingSoonModal,
      requestRacingPageData,
      setIsLangauage
    }

    return { actions: bindActionCreators(actions, dispatch) }
  }

  return connect(mapStateToProps, mapDispatchToProps)(component)
}
